<template>
 <div class="student-records">
  <form class="sr-filters" aria-label="学员课表筛选" @submit.prevent="queryClicked">
   <div class="sr-filter-grid">
    <v-select :items="classItems" item-text="className" item-value="id" label="班级" outlined dense hide-details v-model="query.classId" color="#d9363e" />
    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
     <template v-slot:activator="{on,attrs}"><v-text-field v-model="query.start" label="开始上课日期" readonly dense clearable outlined hide-details v-bind="attrs" v-on="on" color="#d9363e" /></template>
     <v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" />
    </v-menu>
    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
     <template v-slot:activator="{on,attrs}"><v-text-field v-model="query.end" label="结束上课日期" readonly dense clearable outlined hide-details v-bind="attrs" v-on="on" color="#d9363e" /></template>
     <v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" />
    </v-menu>
    <v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id" label="核销状态" dense outlined hide-details color="#d9363e" />
   </div>
   <div class="sr-filter-actions"><span>按班级、上课日期和状态查询</span><v-btn type="submit" depressed color="#d9363e" dark><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div>
  </form>
  <div class="sr-list-heading"><h4>排课记录 <span>{{data.total}} 条</span></h4><div class="sr-legend" aria-label="状态说明"><span class="sr-legend-pending">待核销</span><span class="sr-legend-done">已核销</span><span class="sr-legend-postponed">已顺延</span></div></div>
  <v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="sr-table" :mobile-breakpoint="0" disable-pagination hide-default-footer item-key="id" loading-text="正在加载课表…" no-data-text="暂无符合条件的排课记录">
   <template v-slot:item.courseName="{item}"><span class="sr-course">{{item.courseName}}</span></template>
   <template v-slot:item.className="{item}"><span class="sr-class">{{item.className}}</span></template>
   <template v-slot:item.classDate="{item}"><span class="sr-date">{{item.classDate}}</span></template>
   <template v-slot:item.timeRange="{item}"><span class="sr-time">{{item.timeFrom}}–{{item.timeTo}}</span></template>
   <template v-slot:item.status="{item}"><span class="sr-status" :class="{'sr-status-pending':item.status=='1','sr-status-done':item.status=='2','sr-status-postponed':item.status=='3','sr-status-cancelled':item.status=='0'}">{{statusName(item.status)}}</span></template>
   <template v-slot:item.action="{item}"><v-btn small outlined color="#d9363e" @click="showRecordView(item)">查看<v-icon right size="15">mdi-chevron-right</v-icon></v-btn></template>
   <template v-slot:no-data><div class="sr-empty"><v-icon size="34">mdi-calendar-search</v-icon><h4>暂无符合条件的排课记录</h4><p>可调整班级、日期或核销状态后重新查询</p></div></template>
  </v-data-table>
  <div class="sr-pagination"><div class="sr-page-size"><span>共 <b>{{data.total}}</b> 条</span><v-select :items="[10,20,50,100]" @change="handleSizeChanged" dense hide-details label="每页数量" outlined v-model="query.size" color="#d9363e" /></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handlePageChanged" :total-visible="5" v-model="query.page" color="#d9363e" /></div>
  <recordView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false" />
 </div>
</template>

<script>
	import global from "../config/global"
	import recordView from "./record_info_view.vue"
	export default {
		name:"student-record-list",
		components:{recordView},
		props:{
			studentId:{
				type:String,
				default:""
			},
			classItems:{
				type:Array,
				default:[]
			},
			refreshData:{
				type:String,
				default:""
			}
		},
		watch:{
			// studentId(newVal,oldVal){
			// 	if (newVal&&newVal != oldVal){
					
					
			// 	}
			// },
			refreshData(newVal,oldVal){
				if (newVal&&newVal != oldVal){
					console.log(newVal);
					this.getDataList();
				}
			},
		},
		data(){
			return {
				menu1:false,
				menu2:false,
				query:{
					loading:false,
					page:1,
					size:10,
					classId:"",
					status:"",
					start:"",
					end:"",
					
				},
				selectedItems:[],
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"待核销"},
					{id:"2",statusName:"已核销"},
					{id:"3",statusName:"已顺延"},
				],
				weekItems:global.weekList,
				data: {
					total:0,
					headers:[
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '上课日期',
							value: 'classDate',
							sortable: false
						},
						{
							text: '时间段',
							value: 'timeRange',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							align:'center',
							sortable: false
						},
					],
					list:[],
					
				},
				approve:{
					show:false,
					recordId:""
				},
				recordView:{
					show:false,
					recordId:""
				}
			}
		},
		mounted() {
			console.log("student-record-list mounted");

			this.getDataList();
		
		
		},
		methods:{
			queryClicked(){
				this.query.page = 1;
				this.getDataList();
			},
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			statusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}
			
				return color;
			},
			weekName(wk) {
			
				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
					}
				})
				return stName;
			},
			getDataList(){
				const that = this;
				const studentId = this.studentId;
				let url = `/edu/student/${studentId}/record/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.query.start){
					url += "&start="+this.query.start;
				}
				if(this.query.end){
					url += "&end="+this.query.end;
				}
				if(this.query.status){
					url += "&status="+this.query.status;
				}
				if(this.query.classId){
					url += "&classId="+this.query.classId;
				}
				that.data.list = [];
				that.data.total = 0;		
				this.axios.get(url).then(response => {		
					if (response.data["code"] === 200) {
						
						console.log(">>>>>>>>>>>获取学员课表>>>>>>>>>>>")
						console.log(response.data);
						console.log(">>>>>>>>>>>获取学员课表>>>>>>>>>>>")
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			showApprove(item){
				this.approve.recordId = item.id;
				this.approve.show = true;
			},
			approveSuccess(){
				// 核销成功
				this.approve.show=false;
				this.getDataList();
			},
			showRecordView(item){
				this.recordView.recordId = item.id;
				this.recordView.show = true;
			}
		}
	}
	
</script>

<style lang="scss" scoped>
@import "../assets/styles/student-schedule.scss";
</style>
